import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Box, Divider, IconButton,
} from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AlertMessage from './AlertMessage';
import { humanReadableDate, titleCase, fitnessMembershipStatusColor, fitnessMembershipStatusText } from '../common/AppUtils';

export default function MemberPaymentConfirmationModal({
  open,
  onClose,
  data,
  modal_title="Member added"
}) {
  if (!data) return null;

  const membership = data?.current_membership;
  const current_subscription = membership?.current_subscription;
  const payment_details = membership?.payment_details;  // Could be Null for Legacy Member Onboard

  const totalPaymentValue = payment_details?.total?.amount;
  const hasPayment = totalPaymentValue !== null && totalPaymentValue !== undefined;

  const chipColor = fitnessMembershipStatusColor(current_subscription?.status, current_subscription?.date_status, current_subscription?.is_current);

  const Row = ({ label, value }) => (
    <Box display="flex" justifyContent="space-between" py={0.5}>
      <Typography variant="body2" color="text.secondary">{label}</Typography>
      <Typography variant="body2">{value ?? '—'}</Typography>
    </Box>
  );

  const Section = ({ title, children }) => (
    <Box mb={1.5}>
      <Typography variant="body2" fontWeight={500} mb={0.5}>{title}</Typography>
      <Divider sx={{ mb: 0.5 }} />
      {children}
    </Box>
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: 24
        }
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 0.5 }}>
        <Typography variant="h3">{modal_title}</Typography>
        {true && ( // ToDo: !isSubmitting
          <IconButton edge="end" onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>
      <Divider />
      
      <DialogContent sx={{ pt: 2 }}>
        <Box mb={1.5}>
          <Row label="Name" value={data.full_name} />
          <Row label="Phone" value={data.phone} />
          {/* <Row label="Start" value={membership.joined_at} /> */}
        </Box>
          
        <Section title="Membership">
          <Row label="Plan" value={current_subscription.plan_name} />
          <Row label="Start date" value={current_subscription.start_date} />
          <Row label="Valid till" value={current_subscription.end_date} />
          <Box display="flex" justifyContent="space-between" py={0.5}>
            <Typography variant="body2" color="text.secondary">Status</Typography>
            <Box display="flex" alignItems="center" gap={0.75}>
              <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: chipColor }} />
              <Typography variant="body2" fontWeight="bold" sx={{ color: chipColor }}>{fitnessMembershipStatusText(current_subscription?.status, current_subscription?.date_status, current_subscription?.is_current)}</Typography>
            </Box>
          </Box>
        </Section>

        {payment_details && (
          <Section title="Payment">
            <Row label="Admission" value={payment_details.admission ? `₹ ${parseFloat(payment_details.admission.amount)}` : '—'} />
            <Row label="Fee" value={payment_details.regular ? `₹ ${parseFloat(payment_details.regular.amount)}` : '—'} />
            <Row label="Total" value={hasPayment ? `₹ ${parseFloat(totalPaymentValue)}` : '—'} />
          </Section>
        )}
        {hasPayment ? (
          <AlertMessage
              severity="success"
              message={`Collect ₹ ${parseFloat(totalPaymentValue)} /- from user.`}
            />
        ) : (
          <AlertMessage
            severity="warning"
            message="Payment is not recorded."
          />
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          startIcon={<CheckCircleIcon />}
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
}
